/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ShopifyDeliveryDefaults
 */
export interface ShopifyDeliveryDefaults {
  /**
   *
   * @type {string}
   * @memberof ShopifyDeliveryDefaults
   */
  locationType: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ShopifyDeliveryDefaults
   */
  accessorials: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ShopifyDeliveryDefaults
   */
  distributionWarehouseBrand?: string | null;
}

/**
 * Check if a given object implements the ShopifyDeliveryDefaults interface.
 */
export function instanceOfShopifyDeliveryDefaults(
  value: object,
): value is ShopifyDeliveryDefaults {
  if (!("locationType" in value) || value["locationType"] === undefined)
    return false;
  if (!("accessorials" in value) || value["accessorials"] === undefined)
    return false;
  return true;
}

export function ShopifyDeliveryDefaultsFromJSON(
  json: any,
): ShopifyDeliveryDefaults {
  return ShopifyDeliveryDefaultsFromJSONTyped(json, false);
}

export function ShopifyDeliveryDefaultsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShopifyDeliveryDefaults {
  if (json == null) {
    return json;
  }
  return {
    locationType: json["locationType"],
    accessorials: json["accessorials"],
    distributionWarehouseBrand:
      json["distributionWarehouseBrand"] == null
        ? undefined
        : json["distributionWarehouseBrand"],
  };
}

export function ShopifyDeliveryDefaultsToJSON(
  json: any,
): ShopifyDeliveryDefaults {
  return ShopifyDeliveryDefaultsToJSONTyped(json, false);
}

export function ShopifyDeliveryDefaultsToJSONTyped(
  value?: ShopifyDeliveryDefaults | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    locationType: value["locationType"],
    accessorials: value["accessorials"],
    distributionWarehouseBrand: value["distributionWarehouseBrand"],
  };
}
